import React, { useEffect, useState, createContext } from 'react';
import featureFlagFactory from '@twicapp/ui/helpers/featureFlag';
import type { IFeatureFlag } from '@twicapp/ui/helpers/featureFlag';
import { ANONYMOUS_USER } from 'constants/featureFlag';
import * as Bugsnag from 'utils/bugsnag';

const FeatureFlagContext = createContext<IFeatureFlag>(undefined!);

const renderFeatureFlagContext = ({
  feature_flag,
  children,
}: {
  feature_flag: IFeatureFlag;
  children: JSX.Element;
}) => (
  <FeatureFlagContext.Provider value={feature_flag}>
    {children}
  </FeatureFlagContext.Provider>
);

export const FeatureFlagContextProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const [feature_flag, setFeatureFlag] = useState<IFeatureFlag>();

  useEffect(() => {
    const initFeatureFlag = async () => {
      const ff = await featureFlagFactory(
        process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID!,
        { key: ANONYMOUS_USER, anonymous: true }
      );
      if (ff.error) {
        Bugsnag.notify(ff.error);
      }
      setFeatureFlag(ff.featureFlag);
    };
    initFeatureFlag();
  }, []);

  return !feature_flag
    ? null
    : renderFeatureFlagContext({ feature_flag, children });
};

export default FeatureFlagContext;
